import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_all_wrkrs_offered_any_of_the_following_types_of_development'

export const dataPointDefinition = {
  retracedId: 'are_all_wrkrs_offered_any_of_the_following_types_of_development',
  name: 'Are all workers offered any of the following types of developmental programs by the facility?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'HEALTH_EDUCATION',
      text: 'Health Education',
      externalIds: [
        {
          id: 'ab-1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'GENDER_EQUALITY',
      text: 'Gender Equality',
      externalIds: [
        {
          id: 'ab-1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'GENDER_EMPOWERMENT',
      text: 'Gender Empowerment',
      externalIds: [
        {
          id: 'ab-1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'CAREER_DEVELOPMENT',
      text: 'Career Development',
      externalIds: [
        {
          id: 'ab-1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-1-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-1-5f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'HEALTH_EDUCATION',
                'GENDER_EQUALITY',
                'GENDER_EMPOWERMENT',
                'CAREER_DEVELOPMENT',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-wor-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 23980,
  sectionId: '2.2.2.2',
  impactArea: 'Worker Wellbeing',
  impactAreaId: 'WORKER_WELLBEING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
